/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
exports.shouldUpdateScroll = () => {
    if (window.__navigatingToLink === true) {
        return [0, 0];
    }
    return true;
};

exports.onRouteUpdate = () => {
    if (window.location != null && (window.location.pathname === '/' || window.location.pathname === '/compleet' || window.location.pathname === '/compleet/' || window.location.pathname === '/voor-wie' || window.location.pathname === '/voor-wie/')) {
        require("./src/assets/styles/smoothScroll.css");
    }
    window.__navigatingToLink = false;
};

exports.onClientEntry = () => {
    document.addEventListener("click", (event) => {
        const link = event.target.closest && event.target.closest("a[href]");
        if (link == null || link.hostname.indexOf("weaverfortravel.com") === -1) {
            return;
        }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "weaver_link_click",
            weaver_source_site: "travelspirit.nl",
            weaver_source_page: window.location.pathname,
            weaver_link_url: link.href,
            weaver_link_text: link.textContent.trim(),
        });
    }, true);
};
